module.exports = __webpack_public_path__ + "static/img/zhuanghuo.25e9db77.svg";